import CsCard from './CsCard.vue'
CsCard.install = function (Vue) {
  Vue.component(CsCard.name, CsCard)
}

import DgCard from './DgCard.vue'
DgCard.install = function (Vue) {
  Vue.component(DgCard.name, DgCard)
}

export default [CsCard,DgCard]



// WEBPACK FOOTER //
// ./src/components/card/index.js